import { makeSubStore } from '@jarvis.oddle/core/tools/redux/store'
import { isEmpty } from '@jarvis.oddle/core/tools/string'
import { STORE_KEY } from './constants'
import * as actions from './actions'
import { initialState, reducers } from './reducers'
import { isObjectEmpty } from '@jarvis.oddle/core/tools/object'
import {
  deliveryStatuses
} from '@jarvis.oddle/core/tools/order'

const listOfDriverOnTheWayStatuses = [
  deliveryStatuses.assigned,
  deliveryStatuses.driverOnTheWay
]

const initialiseState = async ({ req, store, parsedUrl }) => {
  const storeOrderId = (parsedUrl && parsedUrl.path && parsedUrl.path[1]) || (req && req.query.storeOrderId)
  const { success, payload } = await store.dispatch(actions.getCheckoutResultsAction({ storeOrderId, req }))
  if (success) {
    const { storeOrder } = payload
    const isDriverOnTheWay = (!isObjectEmpty(storeOrder.deliveryRequestDto) && listOfDriverOnTheWayStatuses.includes(storeOrder.deliveryRequestDto.status))
    // check whether order is delivery order, order status is confirm and driver is on the way then call track delivery api
    if (!storeOrder.isPickup && isDriverOnTheWay && storeOrderId) {
      await store.dispatch(actions.getDeliveryTrackingLinkAction({ storeOrderId, req }))
    }
  }

  if (parsedUrl && parsedUrl.path && parsedUrl.path[0] === 'orders' && req && storeOrderId) {
    const { token } = req.query

    if (!isEmpty(token)) {
      await store.dispatch(actions.verifyAuthenticateTokenAction({ storeOrderId, token, req }))
    }
  }
}

export default makeSubStore(STORE_KEY, actions, reducers, initialState, initialiseState)
